import React from 'react';
import './App.css';
import Home from './components/Home';
import CreateCreditNote from './components/CreateCreditNote';
import EditCreditNote from './components/EditCreditNote';
import FederatedAuthenticator from './components/FederatedAuthenticator';
import { createBrowserRouter } from "react-router-dom";
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';


Amplify.configure(awsExports);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "create-credit-note",
    element: <CreateCreditNote />,
  },
  {
    path: "edit-credit-note/:id",
    element: <EditCreditNote />,
  },
]);

function App() {
  return <FederatedAuthenticator router={router} />;
}

export default App;
